module.exports = {
    apiUrl: window.apiUrl || process.env.VUE_APP_API_URL,
    apiProtocol: window.apiProtocol || process.env.VUE_APP_API_PROTOCOL || 'http'
};
